import "@fontsource/montserrat";

const fonts = {
  body: "Montserrat, sans-serif",
  heading: "Montserrat, sans-serif",
  mono: "Montserrat, sans-serif"
};

export default fonts;
